import { create } from 'zustand';
import { FeatureName } from 'models/feature-toggling.model';
import {
  FeatureTogglesState,
  FeatureTogglesActions,
} from './feature-toggling.type';

const initialState: FeatureTogglesState = {
  featureToggles: null,
};

export const useFeatureTogglesStore = create<
  FeatureTogglesState & FeatureTogglesActions
>((set, get) => ({
  ...initialState,
  setFeatureToggles: (featureToggles) => set({ featureToggles }),
  isFeatureEnabled: (feature: FeatureName): boolean => {
    const toggles = get().featureToggles;

    if (!toggles) return false;

    return toggles[feature];
  },
}));
